exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-qubuilder-faq-js": () => import("./../../../src/pages/qubuilder/faq.js" /* webpackChunkName: "component---src-pages-qubuilder-faq-js" */),
  "component---src-pages-qubuilder-index-js": () => import("./../../../src/pages/qubuilder/index.js" /* webpackChunkName: "component---src-pages-qubuilder-index-js" */)
}

